import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedDataService } from '../../../../service/shared-data.service';


@Component({
  selector: 'app-guest-login',
  templateUrl: './guest-login.component.html',
  styleUrls: ['./guest-login.component.scss'],
})

export class GuestLoginComponent implements OnInit {
  @Input() options: any;
  requestId: string = '';
  btnOption = {    
      text: 'GUEST_LOGIN',
      color: 'accent',
      iconClass: 'cidaas-icon-push'    
  }

  constructor(private _dataService: SharedDataService) { }

  ngOnInit(): void {
    this._dataService._getRequestId().subscribe((res) => {
      if (res) {
        this.requestId = res;
      }
    });
  }

  _actionGuestLogin() {
    console.log("Guest login clicked");
    let guest_url = environment.base_url 
                     + '/login-srv/login' + "/guest/" + this.requestId;
    var loginFormElement = document.getElementsByName('guestLoginForm')[0] as HTMLFormElement;
    loginFormElement.action = guest_url;
    loginFormElement.method = 'post';
    loginFormElement.submit();
    }
    
}
